import Banner from "ds/components/Banner";
import Link from "ds/components/Link";
import useTypedContext from "hooks/useTypedContext";
import { RunState } from "types/generated";
import { VENDOR_CONFIG_TYPENAME } from "constants/vendor";
import { RunContext } from "components/Run/Context";

const DISMISSED_STORAGE_KEY = "conciseLoggingNoticeDismissed";

const CONCISE_LOGGING_STATES = [RunState.Planning, RunState.Applying, RunState.Destroying];

type ConciseLoggingBannerProps = {
  state: RunState;
};

const ConciseLoggingBanner = ({ state }: ConciseLoggingBannerProps) => {
  const { stack } = useTypedContext(RunContext);

  const vendorConfig = stack.__typename === "Stack" ? stack.vendorConfig : undefined;
  const isConcise =
    vendorConfig?.__typename === VENDOR_CONFIG_TYPENAME.OPEN_TOFU && vendorConfig.concise;

  if (!isConcise || !CONCISE_LOGGING_STATES.includes(state)) {
    return null;
  }

  return (
    <Banner variant="info" storageKey={DISMISSED_STORAGE_KEY}>
      You&apos;re not missing anything. OpenTofu concise logging mode filters out progress chatter.
      Want it back?{" "}
      <Link size="inherit" inheritFont href={`/stack/${stack.id}/settings/vendor`}>
        Disable concise logging mode
      </Link>
    </Banner>
  );
};

export default ConciseLoggingBanner;
